import type { FaireProductEntity } from "../../entity_types/product";

export const p_e39g47q543: FaireProductEntity = {
  token: "p_e39g47q543",
  type: "product",
  name: "Cold & Flu for Kids",
  brandToken: "b_63rejl12p8",
  brandName: "Forces of Nature",
  imageUrl:
    "https://cdn.faire.com/fastly/86e6399bc10614185dd7b970bcd1a0ab9dac39d52a5097b7492e0e43d594d07e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/16e3b5a264f254d3c30372b69daf72d47ce972e7857d625a67d1da0e8f09f384.png",
    "https://cdn.faire.com/fastly/d7267ac587b1c2c0a0fd9d71895f4401938b9a38dc316ee199cc1bc82360754a.png",
    "https://cdn.faire.com/fastly/c8630c822b979f72cf439dc1316a77a22f767abb4d312ce7203f187c60531b5a.png",
    "https://cdn.faire.com/fastly/a3220757822c410ef3c933187bcb84b82222138ad36cd8749d20d7e6a6e249bb.jpeg",
    "https://cdn.faire.com/fastly/ce3ae3f48b2687e153abbca968c9dd52d7e7980f1cc3d6674e69f2bad3a26fa8.png",
    "https://cdn.faire.com/fastly/2d14bf657324b2d16ec3c9d6f4f7f3da88f0850dcfb612ee4f71cde65cb0329e.png",
    "https://cdn.faire.com/fastly/e57ee01c2c4f263f653d05ecdd65a8b957509364c80db445c432dc758a15ee96.png",
    "https://cdn.faire.com/fastly/9900d4f89121b4593f1a439de309fee58a577a8eb03c63d20252a4883b0a82da.png",
  ],
  priceDollars: 7.49,
  description:
    "Forces of Nature Cold & Flu Kids is designed for fast-acting relief of congestion, cough, sore throat, fatigue, and body aches. Powered by a blend of certified organic homeopathic ingredients including Sambucus Nigra (Elderberry) and Berberis Vulgaris (Barberry), both packed with antioxidants and known for their ability to support the immune system, this formula helps your child bounce back faster. Cold & Flu Maximum Strength is designed specifically for children with less potent homeopathics. It works to fight symptoms and support immune response without the synthetic ingredients found in conventional products that can cause drowsiness, cotton mouth or other unwanted side effects. Lemon oil and glycerin (USP) provide a natural sweetness that make taking this medicine easy.\n\nCertified Organic, Non-GMO Project Verified, and cruelty free, Cold & Flu Kids sets a higher standard for cold care. Non-drowsy and free from high fructose corn syrup, artificial flavors, or dyes, this clean, plant-based formula works naturally to ease your child’s symptoms. Keep this parent-trusted remedy in your family’s medicine cabinet and use at the first sign of cold and flu symptoms for the best results.\n",
  tags: [],
  msrpDollars: 14.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:57.552Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
